import React from 'react';
import { Spinner } from 'react-bootstrap';

export default function Loading({ waking }) {
  return (
    <div className="d-flex align-items-center text-muted">
      <Spinner animation="border" size="sm" role="status" className="mr-2">
        <span className="sr-only">Loading</span>
      </Spinner>
      {waking ? 'The database is waking up. This can take up to half a minute...' : 'Loading...'}
    </div>
  );
}
